var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93759 10.8981L15.3657 1.47002L14.1872 0.291504L5.93759 8.54108L1.8128 4.41629L0.634288 5.5948L5.93759 10.8981Z",
    fill: "#506176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.8334H0.5V14.5H15.5V12.8334Z",
    fill: "#506176"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckUnderline);
export default __webpack_public_path__ + "static/media/check-underline.c5791c46bc92660c58ef4021bc051a52.svg";
export { ForwardRef as ReactComponent };